import { Avatar, Button, ListItemIcon, ListItemText, MenuItem, Popover, Typography } from '@material-ui/core';
import FirebaseAuthService from 'app/Core/services/FirebaseAuthService';
import history from 'history.js';
import React, { Component } from 'react';
import { MdAccountCircle, MdKeyboardArrowDown, MdLogout } from 'react-icons/md';
import { connect } from 'react-redux';

class UserMenu extends Component {

    state = {
        userMenu: null,
    };

    userMenuClick = event => {
        this.setState({ userMenu: event.currentTarget });
    };

    userMenuClose = () => {
        this.setState({ userMenu: null });
    };


    render() {
        const { user } = this.props;
        const { userMenu } = this.state;
        const { pathname, search } = this.props.location;

        return (
            <React.Fragment>

                <Button className="h-64" onClick={this.userMenuClick}>
                    <Avatar
                        className=""
                        alt={user.data.nome}
                        src={user.data.foto !== null && user.data.foto.length > 0 ? user.data.foto : "assets/images/avatars/profile.png"}
                    />

                    <div className="hidden md:flex flex-col ml-12 items-start">
                        <Typography component="span" className="normal-case font-600 flex">
                            {user.data.displayName}
                        </Typography>
                    </div>

                    <MdKeyboardArrowDown />
                </Button>

                <Popover
                    open={Boolean(userMenu)}
                    anchorEl={userMenu}
                    onClose={this.userMenuClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center'
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center'
                    }}
                    classes={{
                        paper: "py-8"
                    }}
                >
                    <React.Fragment>
                        {user !== undefined && user.data !== undefined && user.data.settings !== undefined &&
                            <MenuItem
                                onClick={() => {
                                    history.push("/conta/editarmeuperfil/" + user.data.idpessoa);
                                    this.userMenuClose();
                                }}
                            >
                                <ListItemIcon>
                                    <MdAccountCircle />
                                </ListItemIcon>
                                <ListItemText className="pl-0" primary="Meu perfil" />
                            </MenuItem>
                        }

                        <MenuItem
                            onClick={() => {
                                FirebaseAuthService.Logout();
                                this.userMenuClose();
                            }}
                        >
                            <ListItemIcon>
                                <MdLogout />
                            </ListItemIcon>

                            <ListItemText className="pl-0" primary="Sair" />
                        </MenuItem>
                    </React.Fragment>
                </Popover>

            </React.Fragment>
        );
    }
}


function mapStateToProps({ auth }) {
    return {
        user: auth.user
    }
}

export default connect(mapStateToProps)(UserMenu);
